export default "__VITE_ASSET__CgcCHgVt__"